import React from 'react';

const Button = ({
  variant = 'primary',
  children,
  onClick,
  startIcon,
  disabled,
  ...props
}) => {
  const getBackgroundColor = () => {
    switch (variant) {
      case 'success': return '#059669';
      case 'danger':  return '#dc2626';
      case 'secondary': return '#64748b';
      default: return '#2563eb';
    }
  };

  const getHoverColor = () => {
    switch (variant) {
      case 'success': return '#047857';
      case 'danger':  return '#b91c1c';
      case 'secondary': return '#475569';
      default: return '#1d4ed8';
    }
  };

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        padding: '10px 20px',
        backgroundColor: disabled ? '#94a3b8' : getBackgroundColor(),
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: '0.9375rem',
        fontWeight: '600',
        fontFamily: 'inherit',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
        boxShadow: disabled ? 'none' : '0 1px 3px rgba(0,0,0,0.12)',
        ...props.style,
      }}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.backgroundColor = getHoverColor();
      }}
      onMouseLeave={(e) => {
        if (!disabled) e.currentTarget.style.backgroundColor = getBackgroundColor();
      }}
      {...props}
    >
      {startIcon && startIcon}
      {children}
    </button>
  );
};

export default Button;
